import React, { ReactNode } from "react";
import { List, Skeleton, Spin, Typography } from "antd";
import { getItemPropertyValue, Item } from "../../data-types";
import styles from "./vpd-list.css";

const {
  ["list-item-content-container"]: contentContainerClassName,
  ["list-item-content"]: contentClassName,
  ["list-item-content-suffix"]: contentSuffixClassName,
} = styles as any;

export type ItemListLabels = {
  emptyText: string;
};

export interface VpdListItemProps {
  key: string | number;
  content: string | ReactNode;
  contentPrefix?: ReactNode;
  contentSuffix?: ReactNode;
}

export const VpdListItem = ({ content, contentPrefix, contentSuffix }: VpdListItemProps) => {
  return (
    <List.Item>
      <div className={contentContainerClassName}>
        {contentPrefix}
        <div className={contentClassName}>{content}</div>
        {contentSuffix && <div className={contentSuffixClassName}>{contentSuffix}</div>}
      </div>
    </List.Item>
  );
};

export const VpdListItemLoading = ({ text }: { text: string }) => {
  const loading = <Spin tip={text}></Spin>;
  return <VpdListItem key={"vpd-list-item-loading"} content={loading} />;
};

export function defaultRenderItem<T extends Item>(
  item: T,
  index: number,
  itemKeyProperty: string,
  itemTextProperty: string
): ReactNode {
  return (
    <VpdListItem
      key={getItemPropertyValue(item, itemKeyProperty)}
      content={<Typography.Text>{getItemPropertyValue(item, itemTextProperty)}</Typography.Text>}
    />
  );
}
